<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" textHeader="Credenciamento PAF NFC-e"
    modalContentId="modal-credenciamento-paf-nfce" customClass="modal-lg">

    <div class="row">
        <div class="col-12">
            <div class="alert alert-info background-info w-100">
                <p class="mb-2">
                    Para realizar o credenciamento da empresa, siga os seguintes passos:
                </p>
                <ol class="credenciamento-list">
                    <li>Acesse o site "CEI - Manutenção de Autorização de Uso de PAF-NFC-e e de BP-e".</li>
                    <li>Clique no botão "[+ Incluir PAF]".</li>
                    <li>Preencha o campo "Tipo de PAF" para "PAF NFCe".</li>
                    <li>Em "Contribuinte ou CNPJ Raiz", selecione a opção "IE" e informe a I.E. do cliente.</li>
                    <li>Clique em Avançar e confirme os dados exibidos em tela.</li>
                    <li>No campo "Aplicativo", selecione a opção "Dim NFC (10.1)" e clique em "[Salvar]".</li>
                </ol>
                <p class="mb-0">
                    Por fim, será exibida uma mensagem na parte superior central da tela. Caso a mensagem indique
                    sucesso, o protocolo de 13 dígitos será exibido junto.<br />
                    Copie esse código e insira no campo <strong>"Protocolo de Atendimento"</strong> desta tela.
                </p>
            </div>
        </div>
    </div>

    <form [formGroup]="form">
        <div class="row mb-3">
            <div class="col-md-4">
                <div class="form-group">
                    <label>Inscrição Estadual</label>
                    <input type="text" class="form-control" [value]="inscricaoEstadual" readonly>
                </div>
            </div>
            <div class="col-md-8">
                <div class="form-group">
                    <label>Nome da Empresa</label>
                    <input type="text" class="form-control" [value]="nomeEmpresa" readonly>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col">
                <div class="form-group">
                    <label>Protocolo de Credenciamento</label>
                    <input type="text" class="form-control" [(ngModel)]="protocolo" name="protocolo" required
                        minlength="13" maxlength="13" pattern="^.{13}$" #protocoloCtrl="ngModel">
                    <div *ngIf="protocoloCtrl.invalid && (protocoloCtrl.dirty || protocoloCtrl.touched)"
                        class="text-danger">
                        <div *ngIf="protocoloCtrl.errors?.required">O protocolo é obrigatório.</div>
                        <div
                            *ngIf="protocoloCtrl.errors?.minlength || protocoloCtrl.errors?.maxlength || protocoloCtrl.errors?.pattern">
                            O protocolo deve conter 13 caracteres.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">
                <button type="button" (click)="salvar()" class="btn btn-primary" [disabled]="form.invalid">
                    Salvar
                </button>
                <button type="button" (click)="modalCadastro.hide()" class="btn btn-danger">
                    Cancelar
                </button>
            </div>
        </div>
    </form>

</app-temp-modal-cadastro>